import { useEffect, useState } from "react";

const pad = (n) => String(Math.max(0, n)).padStart(2, "0");

export default function MaintenanceCountdown({ target }) {
  const [left, setLeft] = useState(() => new Date(target).getTime() - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(new Date(target).getTime() - Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  if (Number.isNaN(left)) return null;
  if (left <= 0) {
    return <p className="text-xs font-black uppercase tracking-[0.25em] text-cyan-300" data-testid="maintenance-countdown-done">Retour imminent…</p>;
  }
  const s = Math.floor(left / 1000);
  const parts = [
    { v: Math.floor(s / 86400), l: "jours" },
    { v: Math.floor((s % 86400) / 3600), l: "heures" },
    { v: Math.floor((s % 3600) / 60), l: "min" },
    { v: s % 60, l: "sec" },
  ].filter((p, i) => i > 0 || p.v > 0);
  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="maintenance-countdown">
      {parts.map((p, i) => (
        <div key={p.l} className="flex items-center gap-2 sm:gap-3">
          <div className="min-w-[64px] rounded-2xl border border-white/10 bg-white/[0.04] px-3 py-2.5 backdrop-blur" style={{ boxShadow: "inset 0 0 20px rgba(56,189,248,.08)" }}>
            <p className="font-display text-2xl font-black tabular-nums text-white sm:text-3xl" style={{ textShadow: "0 0 18px rgba(56,189,248,.55)" }}>{pad(p.v)}</p>
            <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-slate-400">{p.l}</p>
          </div>
          {i < parts.length - 1 && <span className="text-xl font-black text-cyan-400/70">:</span>}
        </div>
      ))}
    </div>
  );
}
